import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark--white",
  "use": "icon-checkmark--white-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-checkmark--white\"><circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"#fff\" /><path d=\"M8 12.882 10.087 15 16 9\" stroke=\"#000\" stroke-width=\"1.29\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol